document.addEventListener('DOMContentLoaded', function () {
  const hiddenItems = document.querySelectorAll('.collection-title.hidden');
  const showMoreButton = document.querySelector('#more_button');
  const showLessButton = document.querySelector('#less_button');
  let isExpanded = false;

  function switchButton() {
    if (isExpanded) {
      hiddenItems.forEach(item => item.classList.add('hidden'));
      if (showLessButton) showLessButton.classList.add('hide-button');
      if (showMoreButton) showMoreButton.classList.remove('hide-button');
    } else {
      hiddenItems.forEach(item => item.classList.remove('hidden'));
      if (showMoreButton) showMoreButton.classList.add('hide-button');
      if (showLessButton) showLessButton.classList.remove('hide-button');
    }
    isExpanded = !isExpanded;
  }

  if (showMoreButton) {
    showMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      switchButton();
    });
  }

  if (showLessButton) {
    showLessButton.addEventListener('click', (e) => {
      e.preventDefault();
      switchButton();
    });
  }
});


  
